import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { TransactionTableViewComponent } from '../../../components/transaction/transaction-table-view/transaction-table-view.component';
import { FilterableTableComponent } from '../../../components/ui/filterable-table/filterable-table.component';
import { Options } from '../../../components/ui/filterable-table/options';
import { TableView } from '../../../components/ui/filterable-table/tableView';
import { TransactionFacade } from '../../../models/transactions/transactionFacade';

@Component({
  selector: 'app-terminal-transactions',
  templateUrl: './terminal-transactions.component.html',
  standalone: false,
})
export class TerminalTransactionsComponent implements OnChanges {
  @Input() merchantId: string | undefined;
  @Input() transactionTypeToPerform: number | undefined;
  @Input() pageSize: number = 10;
  @Output() onTransactionSelected = new EventEmitter<
    Partial<TransactionFacade>
  >();

  @ViewChild('transactionTable') transactionTable:
    | FilterableTableComponent
    | undefined;

  selectedTransaction: Partial<TransactionFacade> | undefined;
  formattedAmount: string | undefined;
  formattedCard: string | undefined;
  settledDate: string | undefined;

  tableView: any;
  tableOptions: Options = new Options({});

  // TODO: duplicate of what's in terminal.component -- put in global
  TRANSACTION_TYPE_AUTHCAPTURE = 0;
  TRANSACTION_TYPE_AUTH = 1;
  TRANSACTION_TYPE_CAPTURE = 2;
  TRANSACTION_TYPE_VOID = 3;
  TRANSACTION_TYPE_REFUND = 4;
  TRANSACTION_TYPE_REVERSAL = 5;
  TRANSACTION_TYPE_RECUR = 6;
  TRANSACTION_TYPE_VALIDATE = 7;

  constructor() {
    this.tableView = new TableView(TransactionTableViewComponent);

    this.tableOptions = new Options({
      pageSize: this.pageSize,
      merchantId: this.merchantId,
      restrictToAction: this.transactionTypeToPerform,
      debug: 'terminal-transactions',
      //selectAction: "details"
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    let change = changes['transactionTypeToPerform'];

    if (change && change.currentValue && change.currentValue != '') {
      this.transactionTable?.setOptions(this.getOptions());
    }
  }

  public clearSelection() {
    this.selectedTransaction = undefined;
  }

  getOptions(): Options {
    return this.tableOptions;
  }

  handleTableInitialized() {
    this.transactionTable?.setOptions(this.getOptions());
  }

  handleRecordSelected(transaction: TransactionFacade) {
    this.selectedTransaction = transaction;
    this.formattedAmount = this.getFormattedAmount();
    this.formattedCard = this.getFormattedCard();
    this.settledDate = this.selectedTransaction.batchDate;

    this.onTransactionSelected.emit(transaction);
  }

  btnCloseDetails_clicked() {}

  btnChangeTransaction_clicked() {
    this.selectedTransaction = undefined;
    this.formattedAmount = undefined;
    this.formattedCard = undefined;
    this.settledDate = undefined;
  }

  getFormattedAmount(): string {
    // if (this.selectedTransaction !== undefined && this.selectedTransaction.magnifiedAmount && this.selectedTransaction.magnifier && this.selectedTransaction.currencyCode) {
    //   return TransactionFacade.getFormattedAmount(this.selectedTransaction.magnifiedAmount, this.selectedTransaction.magnifier, this.selectedTransaction.currencyCode);
    // }
    // else {
    //   return "";
    // }
    return this.selectedTransaction?.totalAmount || '';
  }

  getFormattedCard(): string {
    let s: string = '';

    if (this.selectedTransaction) {
      s =
        this.selectedTransaction.cardType +
        '<br/>' +
        this.selectedTransaction.cardFirst6 +
        '****' +
        this.selectedTransaction.cardLast4 +
        ' ' +
        this.selectedTransaction.cardExpMonth +
        '/' +
        this.selectedTransaction.cardExpYear;
    }

    return s;
  }
}
